import type { ForwardedRef } from 'react'
import { useImperativeHandle, useRef } from 'react'

export function useForwardedRef<T>(ref: ForwardedRef<T>) {
  const targetRef = useRef<T>(null)
  useImperativeHandle<T | null, T | null>(ref, () => targetRef.current)
  return targetRef
}
